export interface ClosedOrderHeadingStats {
  count: number;
  averageDurationSeconds: number | null;
  excludedFromAverage: number;
  date?: Date | string | null;
}

export function closedOrdersTitle(
  stats: ClosedOrderHeadingStats,
  formatDuration: (seconds: number) => string,
  today = new Date()
): string {
  const parts: string[] = [];

  if (stats.count > 0) {
    parts.push(`(${stats.count})`);
  }

  if (stats.averageDurationSeconds !== null) {
    parts.push(`Ø ${formatDuration(stats.averageDurationSeconds)}`);
  }

  if (stats.excludedFromAverage > 0) {
    parts.push(`(${stats.excludedFromAverage} ohne Zeit)`);
  }

  return [headingFor(stats.date, today), ...parts].join(' ');
}

function headingFor(date: Date | string | null | undefined, today: Date): string {
  if (!date) {
    return 'Heute fertiggestellt';
  }

  const selected = new Date(date);
  const isToday =
    selected.getFullYear() === today.getFullYear() &&
    selected.getMonth() === today.getMonth() &&
    selected.getDate() === today.getDate();

  if (isToday) {
    return 'Heute fertiggestellt';
  }

  const day = String(selected.getDate()).padStart(2, '0');
  const month = String(selected.getMonth() + 1).padStart(2, '0');
  return `Fertiggestellt am ${day}.${month}.${selected.getFullYear()}`;
}
